import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
import { html } from "lit";
import { ifDefined } from "lit-html/directives/if-defined.js";
import "../StepNumber/index.js";
import "../../atom/Column/index.js";
import { rif } from "../../../helpers/renderIf.js";
import { styles } from "./styles.js";
import { getNumberClasses, getWrapperClasses, getTitleClasses, getNumberWrapperClasses, getDescriptionClasses, getContentWrapperClasses, getNumber } from "./utils.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let DsfStep = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_title = "";
    this.dsf_description = "";
    this.properties = {
      direction: "horizontal",
      number: 1,
      size: "medium",
      isFirst: false,
      isLast: false
    };
  }
  render() {
    const { direction, size } = this.properties;
    const numberClasses = getNumberClasses(this);
    const wrapperClasses = getWrapperClasses(this);
    const titleClasses = getTitleClasses(this);
    const numberWrapperClasses = getNumberWrapperClasses(this);
    const descriptionClasses = getDescriptionClasses(this);
    const contentWrapperClasses = getContentWrapperClasses(this);
    return html`
      <div class=${wrapperClasses}>
        <span class=${numberWrapperClasses}>
          <dsf-step-number
            class=${numberClasses}
            dsf_state=${ifDefined(this.dsf_state)}
            dsf_size=${size}
          >
            ${getNumber(this)}
          </dsf-step-number>
        </span>
        <dsf-col dsf_gap=${direction === "vertical" ? "xs" : "s"} class=${contentWrapperClasses}>
          ${rif(this.dsf_title, html`<div class=${titleClasses}>${this.dsf_title}</div>`)}
          ${rif(
      this.dsf_description,
      html`<div class=${descriptionClasses}>${this.dsf_description}</div>`
    )}
          <slot></slot>
        </dsf-col>
      </div>
    `;
  }
};
DsfStep.styles = [...BaseComponent.styles, styles];
__decorateClass([
  prop({ type: String })
], DsfStep.prototype, "dsf_state", 2);
__decorateClass([
  prop({ type: String })
], DsfStep.prototype, "dsf_title", 2);
__decorateClass([
  prop({ type: String })
], DsfStep.prototype, "dsf_description", 2);
__decorateClass([
  prop({ type: String })
], DsfStep.prototype, "dsf_legend", 2);
__decorateClass([
  prop({ type: Object })
], DsfStep.prototype, "properties", 2);
DsfStep = __decorateClass([
  defineElement("dsf-step")
], DsfStep);
export {
  DsfStep
};
